import React from 'react';
import countdown from '../assests/countdown.mp4';

const VideoComponent = () => {
  return (
    <div className="video-container">
      <video 
        src={countdown} 
        autoPlay 
        // muted 
        // loop 
        className="fullscreen-video"
      />
    </div>
  );
};

export default VideoComponent;
